import {Component} from "@angular/core";

@Component({
  selector: 'fabric8-pods-list-toolbar',
  templateUrl: './list-toolbar.pod.component.html',
  styleUrls: ['./list-toolbar.pod.component.scss'],
})
export class PodsListToolbarComponent {

}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
